export default __webpack_public_path__ + "static/media/8d45b17f801a5243cb948548275f63dd1602171011748.1fbefda2.webp";